import React from "react";
import Layout from "../Shared/Layout";
import {
    CircularProgress,
    Container,
    Grid,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@material-ui/core";
import styled from "styled-components";
import {InertiaLink, useForm, usePage} from "@inertiajs/inertia-react";
import TextField from "@material-ui/core/TextField";
import MuiButton from "@material-ui/core/Button";
import BackButton from "../Shared/BackButton";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import {Trans} from "../utils/i18n";
import Alert from "@material-ui/lab/Alert";
import {userRegistration} from "../config/userRegistration";
import {userRegistrationXia} from "../config/userRegistrationXia";
import {userRegistrationNIU} from "../config/userRegistrationNIU";
import {userRegistrationBissell} from "../config/userRegistrationBissell";
import {userRegistrationSegway} from "../config/userRegistrationSegway";
import {InputAdornment, Tooltip} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import MuiPhoneNumber from "material-ui-phone-number";
import AddressAutocomplete from "../Shared/AddressAutocomplete";
import {Form as FinalForm} from "react-final-form";

const Wrapper = styled.div``;

const ButtonWrapper = styled.div`
    margin-top: 3rem;
    margin-bottom: 3rem;
`;

const PasswordTooltip = () => {
    return (<Tooltip title={
        <ul>
            <li>
                <Trans i18nKey="password.tooltip.atleast_10_chars">At least 10 characters</Trans>
            </li>
            <li>
                <Trans i18nKey="password.tooltip.lowercase">Lower case characters (a-z)</Trans>
            </li>
            <li>
                <Trans i18nKey="password.tooltip.uppercase">Upper case characters (A-Z) </Trans>
            </li>
            <li>
                <Trans i18nKey="password.tooltip.numbers">Numbers (0-9)</Trans>
            </li>
            <li>
                <Trans i18nKey="password.tooltip.special_chars">
                    Special characters (e.g. @#$%^&amp;*()_+|~-=` {} []:&quot;;&#039;&lt;&gt;/ etc)
                </Trans>
            </li>
        </ul>} arrow={true}>
        <InputAdornment position={"end"}>
            <InfoIcon/>
        </InputAdornment>
    </Tooltip>)
}

export default function Register({countries, client}) {
    const {
        props: {currentCountry},
    } = usePage();

    const {data, setData, post, processing, errors, transform} = useForm({
        token: "",
        name: "",
        company: "",
        country_id: countries[0]['code'] || "",
        email: "",
        timezone: "Europe/Amsterdam",
        language: "en",
        password: "",
        password_confirmation: "",
        responsible_email: "",
        housenumber: "",
        street: "",
        city: "",
        zip: "",
        vat_number: "",
        shippingservice: "",
        returnservice: "",
        contractual_repair_days: "",
    });

    const onSubmit = async (addressData) => {
        transform((data) => ({
            ...data,
            ...addressData
        }))

        post(route("register"));
    };

    const formConfig =
        client.key === "xia"
            ? userRegistrationXia
            : client.key === "niu"
                ? userRegistrationNIU
                : client.key === "segway"
                    ? userRegistrationSegway
                    : client.key === "bissell"
                        ? userRegistrationBissell
                        : userRegistration;

    return (
        <Wrapper>
            <Container maxWidth="md">
                <BackButton label="Login" href={route("login")}/>
                <h1>{formConfig.heading}</h1>

                <FinalForm onSubmit={onSubmit}>
                    {({
                          handleSubmit,
                          submitting,
                          values,
                          form,
                          // errors,
                          touched,
                      }) => {

                        if (values.city !== "" && values.city !== data.city) {
                            setData('city', values.city);
                        }

                        if (values.zip !== "" && values.zip !== data.zip) {
                            setData('zip', values.zip);
                        }

                        if (values.country_id !== "" && values.country_id !== data.country_id) {
                            setData('country_id', values.country_id);
                        }

                        return (
                            <form onSubmit={handleSubmit}>
                                {formConfig.fields.map((field) => {
                                    if (
                                        ["text", "email", "password"].includes(
                                            field.type
                                        )
                                    ) {
                                        return (
                                            <TextField
                                                InputProps={field.name === "password" ? {
                                                    endAdornment: (<PasswordTooltip/>)
                                                } : null}
                                                id={field.name}
                                                label={field.label}
                                                value={data[field.name]}
                                                onChange={(e) => {
                                                    if (["city", "zip"].includes(field.name)) {
                                                        form.change(field.name, e.target.value);
                                                    } else {
                                                        setData(field.name, e.target.value);
                                                    }
                                                }
                                                }
                                                name={field.name}
                                                type={field.type}
                                                required
                                                error={errors[field.name]}
                                                variant={field.variant}
                                                style={field.style}
                                            />
                                        );
                                    } else if (field.type === "select") {
                                        const options =
                                            ['country_id', 'country'].includes(field.name)
                                                ? countries
                                                : field.options;
                                        return (
                                            <FormControl
                                                variant={field.variant}
                                                style={field.style}
                                            >
                                                <InputLabel
                                                    htmlFor={field.name}
                                                >
                                                    {field.label}
                                                </InputLabel>
                                                <Select
                                                    name={field.name}
                                                    native
                                                    label={field.label}
                                                    value={data[field.name]}
                                                    required={
                                                        field.required === true
                                                    }
                                                    onChange={(e) => {
                                                        if (['country_id', 'country'].includes(field.name)) {
                                                            form.change(field.name, e.target.value);
                                                        } else {
                                                            setData(field.name, e.target.value);
                                                        }
                                                    }}
                                                >
                                                    {options.map((item) => (
                                                        ['country_id', 'country'].includes(field.name) ?
                                                            <option key={item.code} value={item.id}>
                                                                {item.name}
                                                            </option>
                                                            :
                                                            <option key={item.key} value={item.value}>
                                                                {item.label}
                                                            </option>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        );
                                    } else if (field.type === "address") {
                                        return (
                                            <AddressAutocomplete
                                                values={values}
                                                field={field}
                                                form={form}
                                            />
                                        );
                                    } else if (field.type === "phoneinput") {
                                        return (
                                            <MuiPhoneNumber
                                                variant={field.variant}
                                                defaultCountry={currentCountry.toLowerCase()}
                                                required={
                                                    field.required === true
                                                }
                                                label={field.label}
                                                onChange={(value) => {
                                                    value = value.replace(
                                                        /\+(\d{1,3})\s0(.+)/,
                                                        "+$1 $2"
                                                    );
                                                    setData(field.name, value);
                                                }}
                                                value={data[field.name]}
                                                sx={{
                                                    "& svg": {height: "1em"},
                                                }}
                                                style={field.style}
                                            />
                                        );
                                    }
                                })}
                                <ButtonWrapper>
                                    <MuiButton
                                        type="submit"
                                        variant="contained"
                                        color="secondary"
                                    >
                                        {!processing && (
                                            <Trans i18nKey="profile.save">
                                                Save
                                            </Trans>
                                        )}
                                        {processing && (
                                            <CircularProgress
                                                style={{
                                                    height: 28,
                                                    width: 28,
                                                }}
                                            />
                                        )}
                                    </MuiButton>
                                </ButtonWrapper>
                                {errors &&
                                    Object.values(errors).map((item) => (
                                        <Alert severity="error">{item}</Alert>
                                    ))}
                            </form>
                        );
                    }}
                </FinalForm>
            </Container>
        </Wrapper>
    );
}

Register.layout = (page) => <Layout children={page}/>;
